<template>
	<Nossr />
</template>
<script>
/* eslint-disable */
export default {
	name: 'UnpaginatedArticle',
	data() {
		return {
		};
    },
    methods:{
		createAdContainers(pageNum, targetEle) {
			const userAgent = navigator.userAgent.toLowerCase();
			const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
			const isEmbdAdFits = document.body.clientWidth < 1121 && document.body.clientWidth > 767;
			const wrapper = document.createElement('div');
			wrapper.className = (isTablet || isEmbdAdFits)? 'module ad emb-top-ad ad-923' : 'module ad emb-top-ad';
			wrapper.id = (isTablet || isEmbdAdFits) ? `ad-top-pos-923-${pageNum}` : `ad-top-pos-141-${pageNum}`;
			const targetElement = document.querySelector(targetEle);
			if(targetElement && targetElement.parentNode) {
				targetElement.parentNode.insertBefore(wrapper, targetElement);
			}
		},
		load141Ad(adId) {
			if (window && window.webmd && window.webmd.adsConsumer) {
				window.webmd.adsConsumer.defineAd({
					id: adId,
					class: 'ad-loaded',
					pos: 141,
					sizes: [[728, 90], [728, 92]],
				});
				window.webmd.adsConsumer.display();
			}
		},

		load121Ad(id) {
			if (window && window.webmd && window.webmd.adsConsumer) {
				window.webmd.adsConsumer.defineAd({
					id: id,
					pos: 121,
					sizes: [[300, 250], [300, 600]],
				});
				window.webmd.adsConsumer.display();
			}
		},
		load137Ad(idx) {
			if (window && window.webmd && window.webmd.adsConsumer) {
				window.webmd.adsConsumer.defineAd({
					id: idx,
					pos: 137,
					sizes: [[300, 250], [300, 600]],
				});
				window.webmd.adsConsumer.display();
			}
		},
		/**
		 * This function is to load the embedded 141 ad on a page which is having video
		 * Load the add once the display() function is called
		 */
		load141AdOnceDisplayCalled() {
			let self = this;
			if (webmd && webmd.ads && webmd.ads.displayCalled && window.webmd.adsConsumer) {
				let adId = 'ad-centerwell-pos-141-1';
				window.webmd.adsConsumer.defineAd({
					id: adId,
					class: 'ad-loaded',
					pos: 141,
					sizes: [[728, 90], [728, 92]],
				});
				webmd.ads.refresh({id:'ad-centerwell-pos-141-1'});
			} else {
				setTimeout(function() {
					self.load141AdOnceDisplayCalled();
				}, 100);
			}
		},

		//right rail ad containers
		createRRContainers(page, isOncology, isSiteFronts) {
			var index = page - 1;
			var newRecommended;
			let rightRailContainer = document.querySelector('div.main-container.main-container-3');
			let elementLength = rightRailContainer.children.length - 1;
			var rightRailLastElid = '#' + rightRailContainer.children[elementLength].getAttribute('id');
			let wrapperOneTwoOne = '<div id="ads2-pos-121-ad-right-rr-container' + page + '" class="module ad ads2-pos-121-ad-right-cont">'+
				'<div id="ads2-pos-121-ad-right-rr' + page + '" class="up-rr-ad pos-121-ad-right-rr"></div>'+
				'</div>';
			let wrapperOneThreeSeven =  '<div id="ads2-pos-137-ad-right-rr-container' + page + '" class="module ad ads2-pos-137-ad-right-cont">'+
				'<div id="ads2-pos-137-ad-right-rr' + page + '" class="up-rr-ad pos-137-ad-right-rr"></div>'+
				'</div>';
			const lastPage = document.querySelector('.article-page:last-child');
			const lastPageNum = parseInt(lastPage.dataset.page);		
	
			if (page === 2) {
					let targetOneTwoOneOnc = document.querySelector(rightRailLastElid);
					targetOneTwoOneOnc.insertAdjacentHTML('afterend', wrapperOneTwoOne);
					let adslotEle = '#ads2-pos-121-ad-right-rr-container' + page;
					let targetOneThreeSevenOnc = document.querySelector(adslotEle);
					if (!(page === lastPageNum && lastPage.offsetHeight < 800)) {
						targetOneThreeSevenOnc.insertAdjacentHTML('afterend', wrapperOneThreeSeven);
					}
			}
			if (page >= 3) {
					let pos137AdIdPrev = '#ads2-pos-137-ad-right-rr-container' + index;
					let pos137AdIdPrevEle = document.querySelector(pos137AdIdPrev);
					pos137AdIdPrevEle.insertAdjacentHTML('afterend', wrapperOneTwoOne);

					let pos121AdOncCurrent = '#ads2-pos-121-ad-right-rr-container' + page;
					let pos121AdOncCurrentElment = document.querySelector(pos121AdOncCurrent);
					if (!(page === lastPageNum && lastPage.offsetHeight < 800)) {
						pos121AdOncCurrentElment.insertAdjacentHTML('afterend', wrapperOneThreeSeven);
					}
			}
		},
    }
};
</script>
<style lang="scss">
.webmd-onc-article {
	.main-container-3 .ad {
		&.ads2-pos-121-ad-right-cont  {
			align-items: start;
		}
		&.ads2-pos-137-ad-right-cont {
			align-items: start;
		}

		.up-rr-ad {
			min-height: px2rem(250);
			position: sticky;
			top: 0;
			width: 100%
		}
	}
}

</style>

